<template>
  <div :class="`custom-logo-wrapper ${size} ${genderClass} ${customClasses}`">
    <div class="logo-content" :class="{'multiple-tags': (displayTitle && gender)}">
        <div class="background-wrapper"></div>
        <div class="title-tags">
            <span v-if="mainHeader" class="main-header-tag">
                {{mainHeader}}
            </span>

            <span class="title-tag" v-if="displayTitle">{{displayTitle}}</span>
        </div>
    </div>
  </div>
</template>

<script>
import { PLAYER_GENDERS, TEAM_GENDERS } from '@/constants/genderConsts'

export default {
  name: 'CustomEmblem',
  props: [
    'gender',
    'customClasses',
    'subHeader',
    'size'
  ],
  data () {
    return {
      titleSize: 5
    }
  },
  computed: {
    genderClass () {
      switch (this.gender) {
        case PLAYER_GENDERS.MALE:
        case TEAM_GENDERS.BOYS:
          return 'male-logo'

        case PLAYER_GENDERS.FEMALE:
        case TEAM_GENDERS.GIRLS:
          return 'female-logo'

        case TEAM_GENDERS.MIXED:
        case 'MIX':
          return 'mixed-gender-logo'

        default:
          return 'mixed-gender-logo'
      }
    },
    displayTitle () {
      if (this.subHeader.push) {
        return
      }

      return this.subHeader.length > this.titleSize ? this.subHeader.substring(0, this.titleSize) : this.subHeader
    },
    mainHeader () {
      var displayTitle = ''

      if (this.subHeader.length && this.subHeader.push) {
        this.subHeader.forEach(function (title, i) {
          if (title) {
            displayTitle += title.length >= 1 ? title.substring(0, 1) : ''
          }
        })
      }

      if (!displayTitle) {
        switch (this.gender) {
          case PLAYER_GENDERS.MALE:
          case TEAM_GENDERS.BOYS:
            return 'B'

          case PLAYER_GENDERS.FEMALE:
          case TEAM_GENDERS.BOYS.GIRLS:
            return 'G'

          case TEAM_GENDERS.MIXED:
          case 'MIX':
            return 'M'
        }
      }

      return displayTitle
    }
  }
}
</script>
